import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActions as commonApiActions, apiResourceActionCreator } from "../../common";
import { authTokenSelector } from '../../session';
import { API_ENDPOINT } from './endpoints';

const action = createActions({
  API_KEY: {
    GENERATE_KEY: undefined,
    API: {
      GENERATE_KEY: apiResourceActionCreator('key')
    }
  }
})

export const apiAction = (authToken) => commonApiActions.authenticated.get(`${API_ENDPOINT}/generate-key`, authToken, action.apiKey.api.generateKey)

function* generateKey(action) {
  const authToken = yield select(authTokenSelector);
  yield put(apiAction(authToken));
}

const configuration = {
  name: 'generateKey',
  action: action,
  sagas: generateKey,
  reducers: {
    request: (state, action) => ({
      ...state,
      isFetching: true
    }),
    success: (state, action) => ({
      ...state,
      isFetching: false,
      keys: state.keys.concat([action.payload.key])
    }),
    failed: (state, action) => ({
      ...state,
      isFetching: false
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/api-key/configurations/generateKey.js